import { useState } from 'react';

import { useAuth } from '@chainlit/react-client';

import { useTranslation } from '@/components/i18n/Translator';

import ProfileEditDialog from './ProfileEditDialog';
import ProfileSection from './ProfileSection';

// Dummy data for demonstration
const dummyUser = {
  name: 'John Doe',
  email: 'john.doe@example.com',
  avatar: ''
};

const ProfileDashboard = () => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [editDialogOpen, setEditDialogOpen] = useState(false);

  // Handler functions for actions
  const handleEditProfile = () => {
    setEditDialogOpen(true);
  };

  // Create user object from real auth data
  const realUser = user
    ? {
        name: user.display_name || user.identifier || 'User',
        email: user.metadata?.email || user.identifier || 'user@example.com',
        avatar: user.metadata?.image || ''
      }
    : dummyUser;

  // Create connected accounts from user metadata
  const connectedAccounts = user
    ? [
        {
          provider: 'Google', // You might want to derive this from user.metadata or other source
          email: user.metadata?.email || user.identifier || 'user@example.com',
          isConnected: true
        }
      ]
    : [
        {
          provider: 'Google',
          email: 'john.doe@example.com',
          isConnected: true
        }
      ];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">
          {t('profile.title')}
        </h2>
        <p className="text-gray-600">{t('profile.description')}</p>
      </div>

      <ProfileSection
        user={realUser}
        connectedAccounts={connectedAccounts}
        onEditProfile={handleEditProfile}
      />

      <ProfileEditDialog
        open={editDialogOpen}
        onOpenChange={setEditDialogOpen}
      />
    </div>
  );
};

export default ProfileDashboard;
